export default "__VITE_ASSET__DNmnbF9G__"